import React, { forwardRef, useEffect, useRef, useState } from "react";
import { createUseStyles } from "react-jss";
import { pxToRem, toNumberFixed } from "@/util/common";
import FixedNavBar from "@/components/fixedNavBar";
import CalendarTime from "@/components/calendarTime";
import API from "@/api";
import { isEmpty } from "lodash";
import { Skeleton } from "antd-mobile";
import useCustomTranslation from "@/hooks/useTranslation";
import useRouter from "@/hooks/useRouter";
import DropTime from "@/components/dropTime";

const CalendarTimeChildComponent = forwardRef(CalendarTime);

const Finance: React.FC = () => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const { customNavigate } = useRouter();
	const childRef = useRef<any>(null);
	const [dataList, setDataList] = useState<Record<string, any>>({});

	const postFinanceAgentHomeFinaceHandle = async () => {
		try {
			const params: any = {};
			if (childRef.current) {
				params["startTime"] = childRef.current.startTime;
				params["endTime"] = childRef.current.endTime;
			}
			const result: any = await API.finances.apiFinanceAgentHomeFinace(
				params
			);
			if (result?.code === 0) {
				const contentData = result.content.data;
				setDataList(contentData);
			}
		} catch (error) {
			console.log("---apiFinanceAgentHomeFinace--:", error);
		}
	};
	useEffect(() => {
		postFinanceAgentHomeFinaceHandle();
	}, []);

	const daysToSubtract = useRef<number>(30);
	const handleOptionClick = (newIndex: number) => {
		daysToSubtract.current = newIndex;
		postFinanceAgentHomeFinaceHandle();
	};
	return (
		<div className="router-main">
			<FixedNavBar
				title={t("Finance")}
				rightContent={[
					<DropTime
						key="dropTime"
						index={daysToSubtract.current}
						handleOptionClick={handleOptionClick}
					/>,
				]}
			/>
			<div className={classes.timeWrap}>
				<CalendarTimeChildComponent
					ref={childRef}
					daysToSubtract={daysToSubtract.current}
					onSubmit={postFinanceAgentHomeFinaceHandle}
				/>
			</div>

			<div className="router-view">
				<div className={classes.FinanceWrap}>
					<div className="itemFinanceWrap">
						<div className="itemFinance balance">
							<p>{t("Balance")}</p>
							<h2>
								{!isEmpty(dataList) ? (
									toNumberFixed(dataList.balance, 2)
								) : (
									<Skeleton
										animated
										style={{
											height: pxToRem(42),
											width: pxToRem(100),
											margin: "0 auto",
										}}
									/>
								)}
							</h2>
						</div>
						<div
							onClick={() => {
								customNavigate("/game-records?t=" + Date.now());
							}}
							className="itemFinance waget"
						>
							<p>{t("Pnl")}</p>
							<h2>
								{!isEmpty(dataList) ? (
									toNumberFixed(dataList.profit, 2)
								) : (
									<Skeleton
										animated
										style={{
											height: pxToRem(42),
											width: pxToRem(100),
											margin: "0 auto",
										}}
									/>
								)}
							</h2>
						</div>
						<div
							onClick={() => {
								customNavigate(
									"/recently-recharge?t=" + Date.now()
								);
							}}
							className="itemFinance deposit"
						>
							<p>{t("Deposit")}</p>
							<h2>
								{!isEmpty(dataList) ? (
									toNumberFixed(dataList.deposit, 2)
								) : (
									<Skeleton
										animated
										style={{
											height: pxToRem(42),
											width: pxToRem(100),
											margin: "0 auto",
										}}
									/>
								)}
							</h2>
						</div>
						<div
							onClick={() => {
								customNavigate(
									"/recently-recharge?t=" + Date.now()
								);
							}}
							className="itemFinance withdraw"
						>
							<p>{t("Withdraw")}</p>
							<h2>
								{!isEmpty(dataList) ? (
									toNumberFixed(dataList.cash, 2)
								) : (
									<Skeleton
										animated
										style={{
											height: pxToRem(42),
											width: pxToRem(100),
											margin: "0 auto",
										}}
									/>
								)}
							</h2>
						</div>
					</div>
					<ol className={classes.tipsWrap}>
						<li>{t("FinanceTips1")}</li>
						<li>{t("FinanceTips2")}</li>
					</ol>
				</div>
			</div>
		</div>
	);
};

export default Finance;

const useStyles = createUseStyles({
	FinanceWrap: {
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(30),
			top: pxToRem(6),
		},

		"& .itemFinance": {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			color: "#FFFFFF",
			flexDirection: "column",
			height: pxToRem(100),
			borderRadius: pxToRem(10),
			marginBottom: pxToRem(6),
			// border: "1px solid",
			borderImageSource:
				"linear-gradient(180deg, #2E3A61 0%, #353F63 100%)",
			"&:active": {
				opacity: 0.8,
			},
			"& p": {
				fontSize: pxToRem(14),
				fontWeight: "400",
				lineHeight: pxToRem(22),
			},
			"& h2": {
				fontSize: pxToRem(28),
				fontWeight: "700",
				lineHeight: pxToRem(42),
			},
			"&.balance": {
				background:
					"linear-gradient(156deg, #FFB21E 5.2%, #BA6500 97.46%)",
			},
			"&.deposit": {
				background:
					"linear-gradient(156deg, #32FDFD 5.2%, #3B69C3 97.46%)",
			},
			"&.waget": {
				background:
					"linear-gradient(156deg, #D274FF 5.2%, #9336EF 97.46%)",
			},
			"&.withdraw": {
				background:
					"linear-gradient(156deg, #191942 5.2%, #4674FE 97.46%)",
			},
		},
	},
	timeWrap: {
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
		},
	},
	tipsWrap: {
		paddingTop: pxToRem(14),
		color: "#868FA8",
		"& li": {
			fontSize: pxToRem(14),
			fontWeight: "400",
			lineHeight: pxToRem(22),
		},
	},
});
